import { useState } from "react";
import Header from "./Components/header/Header";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="app-wrapper">
      <Header onToggle={() => setCollapsed(!collapsed)} />
      <div className={`main-section ${collapsed ? "collapsed" : ""}`}>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Layout;